import React, { useEffect } from "react";
import LanguageSelection from "./pages/LanguageSelection";
import { useLocation } from "react-router-dom";
import useGeoLocation from "./components/hooks/useGeoLocation";
import locationImage from "./assets/locationImage.svg";
import RegistrationForm from "./pages/RegistrationForm";

const App = () => {
  const search = useLocation().search;
  // const location = useGeoLocation();
  const templateCode = new URLSearchParams(search).get("template_code");
  useEffect(() => {
    localStorage.setItem("template_code", templateCode);
  }, [templateCode]);
  return (
    <>
      {/* {location.loading && (
        <div
          style={{
            marginTop:100,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={locationImage} alt="loading" />
          <h3 className="text-center text-indigo-800 text-xl font-semibold">
            Please wait... Finding your location
          </h3>
        </div>
      )}
         {!location.location && !location.loading && (
        <div
          style={{
            marginTop:100,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={locationImage} alt="loading"  />
          <h3 className="text-center text-indigo-800 text-xl font-semibold">
          Please allow location and refresh the screen
          </h3>
        </div>
      )} */}
      {/* {location.location && ( */}
      <div className="flex flex-col items-center mx-auto overflow-scroll h-screen">
        <LanguageSelection templateCode={templateCode} />
      </div>
      {/* )} */}
    </>
  );
};

export default App;
